import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Col, Row } from 'antd';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import BoxDash from '../../Components/BoxDash';
import GaugeChart from 'react-gauge-chart'; // Importação do GaugeChart
import { api } from '../../services/apiClient';
import { useAuth } from '../../contexts/AuthContext';
import TableColabores from '../../Components/TableColabores';
import Graphs from '../../Components/Graphs';
import moment from 'moment'; // Adicione moment para manipulação de datas

const Dashboard = () => {
  const { user } = useAuth();

  const [operacoes, setOperacoes] = useState([]);
  const [subOperacoes, setSubOperacoes] = useState([]);
  const [dadosTabela, setDadosTabela] = useState([]);
  const [totaisPorStatus, setTotaisPorStatus] = useState([]);
  const [totalCobrarDia, setTotalCobrarDia] = useState();
  const [totalEmprestado, setTotalEmprestad] = useState();
  const [totalPagos, setTotalPagos] = useState(0);
  const [atrasados, setAtrasados] = useState();
  const [valorAreceberJuros, setValorAreceberJuros] = useState();
  const [dataDash, setDataDash] = useState();

  const fetchOperacoes = async () => {
    try {
      const response = await api.get(`/operation`);
      setProgress(100);
      setOperacoes(response.data);
      setDadosTabela(response.data.operacoes);
      setTotaisPorStatus(response.data.totaisPorStatus);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await api.get('/dashboard');
      setDataDash(response.data);
    } catch (error) {
      console.log('error', error.message)
      setDataDash([]);
      console.error('Failed to fetch data:', error);
    }
  };

  const fetchSubOperacoes = async () => {
    try {
      const response = await api.get(`/suboperation`);
      setProgress(100);
      setSubOperacoes(response.data);
      setDadosTabela(response.data.operacoes);
    } catch (error) {
      console.error(error);
      console.log('error', error);
    }
  };


  useEffect(() => {
    if (user && user?.tipoUsuario < 2) {
      fetchOperacoes();
      fetchSubOperacoes();
      fetchData();
    } else {
      fetchData();
      fetchSubOperacoes();
    }
  }, []);

  const onChildUpdate = () => {
    fetchOperacoes();
    // fetchTotalPagos();
  };

  const [progress, setProgress] = useState(0);

  const simulateProgress = () => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setProgress(progress);
      if (progress >= 100) clearInterval(interval);
    }, 100); // Atualiza o progresso a cada segundo
  };

  useEffect(() => {
    simulateProgress();
  }, []);

  const formatarValor = (valor) => {
    if (!valor) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  };

  // Calcula o valor total de recebidos e a receber
  const totalHoje = (dataDash?.numerosHoje || 0) + (dataDash?.recebidoHoje || 0);

  return (
    <div className={styles.container}>
      <Breadcrumb
        items={[
          {
            title: (
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='24' viewBox='0 0 23 24' fill='none'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.2 3.32275C10.3525 3.32275 9.52129 3.55496 8.79652 3.99415L4.15884 6.80459C3.47686 7.21786 2.91295 7.8 2.52159 8.49478C2.13022 9.18957 1.92462 9.97352 1.92464 10.7709V16.607C1.92464 17.837 2.41325 19.0166 3.28298 19.8863C4.15272 20.7561 5.33233 21.2447 6.56232 21.2447H15.8377C17.0677 21.2447 18.2473 20.7561 19.117 19.8863C19.9867 19.0166 20.4754 17.837 20.4754 16.607V10.77C20.4752 9.97279 20.2695 9.18885 19.8781 8.49428C19.4868 7.79972 18.923 7.21776 18.2412 6.8046L13.6035 3.99416C12.8787 3.55497 12.0475 3.32275 11.2 3.32275ZM9.75792 5.58066C10.1928 5.31715 10.6915 5.17783 11.2 5.17783C11.7085 5.17783 12.2072 5.31715 12.6421 5.58066L17.2798 8.39109C17.6888 8.63899 18.0271 8.98817 18.2619 9.40492C18.4967 9.82159 18.6201 10.2918 18.6203 10.77V16.607C18.6203 17.345 18.3271 18.0528 17.8053 18.5746C17.2834 19.0964 16.5757 19.3896 15.8377 19.3896H14.9101V16.607C14.9101 15.623 14.5193 14.6793 13.8235 13.9835C13.1277 13.2878 12.184 12.8969 11.2 12.8969C10.216 12.8969 9.27232 13.2878 8.57653 13.9835C7.88074 14.6793 7.48985 15.623 7.48985 16.607V19.3896H6.56232C5.82432 19.3896 5.11656 19.0964 4.59472 18.5746C4.07288 18.0528 3.77971 17.345 3.77971 16.607V10.7709C3.7797 10.2925 3.90306 9.82209 4.13788 9.40522C4.3727 8.98835 4.71104 8.63906 5.12023 8.3911L9.75792 5.58066ZM12.5117 15.2953C12.8596 15.6432 13.0551 16.115 13.0551 16.607V19.3896H9.34493V16.607C9.34493 16.115 9.54037 15.6432 9.88826 15.2953C10.2362 14.9474 10.708 14.7519 11.2 14.7519C11.692 14.7519 12.1638 14.9474 12.5117 15.2953Z'
                    fill='#757575'
                  />
                </svg>
              </Link>
            ),
          },
          {
            title: (
              <>
                <span>Dashboard</span>
              </>
            ),
          },
        ]}
      />
      <Row justify='space-between' className={styles.row} gutter={[24, 24]}>
        {user?.tipoUsuario < 3 && (
          <Col xs={24} sm={24} md={24} lg={24} className={` ${styles.fullWidthOnSmallScreen}`}>
            <div className={styles.col}>
              <div className={styles.title}>Contratos</div>
              <BoxDash type1='Aberto Qtn.' quantidade={dataDash?.geral} value={formatarValor(dataDash?.geralValor)} type2='Aberto Valor'></BoxDash>
            </div>
          </Col>
        )}

        <Col xs={24} sm={12} md={12} lg={12}>
          <div className={styles.col}>
            <div className={styles.title}>Contratos Mês</div>
            <BoxDash type1='Recebidos Qtn.' quantidade={dataDash?.mes?.recebido?.quantidade} value={formatarValor(dataDash?.mes?.recebido?.valor)} type2='Recebidos Valor' background='#E9F9EE' color='#26BF56' borderColor='#BCEBCB'></BoxDash>
            <BoxDash type1='À Receber Qtn.' quantidade={dataDash?.mes?.aReceber?.quantidade} value={formatarValor(dataDash?.mes?.aReceber?.valor)} type2='À Receber Valor' background='#FEF5E7' color='#F6970A' borderColor='#FCDFB3'></BoxDash>
            <BoxDash type1='Atrasados Qtn.' quantidade={dataDash?.mes?.atrasado?.quantidade} value={formatarValor(dataDash?.mes?.atrasado?.valor)} type2='Atrasados Valor' background='#FDECEC' color='#EB4143' borderColor='#F9C4C5'></BoxDash>
          </div>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <div className={styles.col}>
            <div className={styles.title}>Contratos Hoje</div>
            <BoxDash type1='Recebidos Qtn.' quantidade={dataDash?.hoje?.recebido?.quantidade} value={formatarValor(dataDash?.hoje?.recebido?.valor)} type2='Recebidos Valor' background='#E9F9EE' color='#26BF56' borderColor='#BCEBCB'></BoxDash>
            <BoxDash type1='À Receber Qtn.' quantidade={dataDash?.hoje?.aReceber?.quantidade} value={formatarValor(dataDash?.hoje?.aReceber?.valor)} type2='À Receber Valor' background='#FEF5E7' color='#F6970A' borderColor='#FCDFB3'></BoxDash>
            {/* <BoxDash type1='Atrasados Qtn.' quantidade={dataDash?.hoje?.atrasado?.quantidade} value={formatarValor(dataDash?.hoje?.atrasado?.valor)} type2='Atrasados Valor' background='#FDECEC' color='#EB4143' borderColor='#F9C4C5'></BoxDash> */}
            {/* <GaugeChart id='gauge-chart1' percent={dataDash?.recebidoHoje / totalHoje || 0} colors={['#fc0303', '#fcf003', '#03fc0b']} arcWidth={0.3} textColor='#000000' /> */}
          </div>
        </Col>
      </Row>

      <div className={styles.containerTable}>
        {/* {user && user.tipoUsuario < 2 ? <Graphs dataTabeColab={subOperacoes} onChildUpdate={onChildUpdate} progress={progress} /> : <TableColabores data={subOperacoes} onChildUpdate={onChildUpdate} progress={progress} />} */}
        {user && user?.tipoUsuario < 2 ? <></> : <TableColabores data={subOperacoes} onChildUpdate={onChildUpdate} progress={progress} />}
      </div>
    </div>
  );
};

export default Dashboard;
